import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Create a Spellingframe account", -1)
const _hoisted_2 = { class: "sm:tw-grid sm:tw-grid-cols-2 sm:tw-gap-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, " School name* ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, " Your first name* ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, " Your last name* ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " Your email address* ", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, " Confirm your email address* ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, " School address line 1* ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, " School address line 2 ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, " School address line 3 ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, " Post code* ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, " Password* ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, " Confirm password* ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-4" }, [
  /*#__PURE__*/_createTextVNode(" I have read, understood, and agree to the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/sitemedia/Spellingframe_Terms_and_Conditions_FULL_v1.pdf",
    target: "sf_tos"
  }, "terms and conditions")
], -1)
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountShortDescription = _resolveComponent("AccountShortDescription")!
  const _component_ContactLink = _resolveComponent("ContactLink")!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_RegisterResume = _resolveComponent("RegisterResume")!
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_RegisterResume, null, {
          title: _withCtx(() => [
            _createTextVNode(" School Account ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_AccountShortDescription, { type: "school" })
          ]),
          switch: _withCtx(() => [
            (_ctx.mfTokenData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(" If you would prefer to register as an individual user please "),
                  _createVNode(_component_ContactLink),
                  _createTextVNode(" for further assistance. ")
                ]))
              : (_openBlock(), _createBlock(_component_SfRouterLink, {
                  key: 1,
                  to: '/register/individual'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Switch to individual account ")
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("form", {
          ref: "registerForm",
          onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("fieldset", {
            disabled: _ctx.status == 'loaded'
          }, [
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.school_n,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fields.school_n) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fields.school_n.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.school_n.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.first_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fields.first_name) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.fields.first_name.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.first_name.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.last_name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.fields.last_name) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fields.last_name.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.last_name.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.email,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.fields.email) = $event)),
              "custom-errors": { exists: 'A user with this email already exists' }
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                (_ctx.mfTokenData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.formData.fields.email.value), 1))
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.fields.email.value) = $event)),
                      class: "sf-form-control tw-w-full"
                    }, null, 512)), [
                      [_vModelText, _ctx.formData.fields.email.value]
                    ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (!_ctx.mfTokenData)
              ? (_openBlock(), _createBlock(_component_FormInput, {
                  key: 0,
                  modelValue: _ctx.formData.fields.adminEmailConfirm,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.fields.adminEmailConfirm) = $event)),
                  "all-fields": _ctx.formData.fields,
                  "custom-errors": { match: 'Emails don\'t match' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.fields.adminEmailConfirm.value) = $event)),
                      class: "sf-form-control tw-w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.formData.fields.adminEmailConfirm.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "all-fields"]))
              : _createCommentVNode("", true),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.address1,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.fields.address1) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.fields.address1.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.address1.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.address2,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.fields.address2) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.fields.address2.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.address2.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.address3,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.fields.address3) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.fields.address3.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.address3.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.postcode,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.fields.postcode) = $event)),
              "custom-errors": {
              exists: 'A school with this postcode already exists',
            }
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.fields.postcode.value) = $event)),
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.postcode.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.password,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.fields.password) = $event)),
              "custom-errors": {
              minLength: 'passwords must be at least 6 characters long',
            }
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.fields.password.value) = $event)),
                  autocomplete: "off",
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.password.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_FormInput, {
              modelValue: _ctx.formData.fields.passwordConfirm,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.fields.passwordConfirm) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.fields.passwordConfirm.value) = $event)),
                  autocomplete: "off",
                  class: "sf-form-control tw-w-full"
                }, null, 512), [
                  [_vModelText, _ctx.formData.fields.passwordConfirm.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 8, _hoisted_4),
          _hoisted_17,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.status == 'loaded',
              class: "sf-btn-primary"
            }, " Register ", 8, _hoisted_18)
          ])
        ], 544)
      ])
    ])
  ], 64))
}